import axios from "axios";

const http = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: { "Content-Type": "application/json" },
});

// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 添加响应拦截器
http.interceptors.response.use(
  (response) => {
    const res = response.data;
    const statusCode = response.status;
    if (statusCode === 401) {
      return response;
    }
    return res;
  },
  (error) => {
    // 响应异常清除缓存
    return Promise.reject({ err: error, code: 0 });
  }
);

export default http;
